import { Checkbox, Select } from 'antd';
import TransComponent from 'components/TransComponent';
import { FV, PlatformProps } from './share';
import {
  cancelTradeScenarios,
  isLogisticsScenarioType,
  isReturnTradeScenarioType,
  systemCancelTradeScenarios,
} from '../config';
import { useEffect, useState } from 'react';
import { T, useTranslate } from '@tolgee/react';

interface FilterConsultBuyerProps extends PlatformProps {
  touched?: boolean;
  scenarioType: Marketing.AllScenarioType;
  disabled?: boolean;
  filterConsultBuyer: FV['filterRule']['filterConsultBuyer'];
  onChange: (filterConsultBuyer: FV['filterRule']['filterConsultBuyer']) => void;
}

export const disable1Platform: General.PlatformUpperCase = 'TOKOPEDIA';

export const isFilterEnable1ScenarioType = (scenarioType: Marketing.AllScenarioType) =>
  scenarioType === 'PAYMENT_REMINDER' ||
  scenarioType === 'POSITIVE_REVIEW_CARE' ||
  isLogisticsScenarioType(scenarioType);

export const isFilterEnable3ScenarioType = (scenarioType: Marketing.AllScenarioType) =>
  scenarioType === 'PRAISE_REMINDER' ||
  scenarioType === 'NEGATIVE_REVIEW_SAVE' ||
  cancelTradeScenarios.includes(scenarioType as any) ||
  systemCancelTradeScenarios.includes(scenarioType as any) ||
  isReturnTradeScenarioType(scenarioType);

export const FilterConsultBuyer = (props: FilterConsultBuyerProps) => {
  const { touched, scenarioType, disabled, platform, filterConsultBuyer, onChange } = props;
  const { t } = useTranslate();
  const [enable, setEnable] = useState(
    filterConsultBuyer?.filterWaitProcessConversation ||
      filterConsultBuyer?.filterConsult ||
      filterConsultBuyer?.filterConsultAfterCreateOrder,
  );

  useEffect(() => {
    if (!touched) {
      setEnable(
        filterConsultBuyer?.filterWaitProcessConversation ||
          filterConsultBuyer?.filterConsult ||
          filterConsultBuyer?.filterConsultAfterCreateOrder,
      );
    }
  }, [touched, filterConsultBuyer]);

  if (!filterConsultBuyer) return null;

  const {
    filterWaitProcessConversation,
    filterConsult,
    filterConsultDays,
    filterConsultAfterCreateOrder,
  } = filterConsultBuyer;

  return (
    <div className="pt-1">
      <Checkbox
        disabled={disabled}
        checked={enable}
        onChange={({ target: { checked } }) => {
          setEnable(checked);

          onChange({
            ...filterConsultBuyer,
            filterWaitProcessConversation: checked
              ? isFilterEnable1ScenarioType(scenarioType) && platform !== disable1Platform
              : false,
            filterConsult: false,
            filterConsultAfterCreateOrder: checked
              ? isFilterEnable3ScenarioType(scenarioType)
              : false,
          });
        }}
      >
        {t('aide.过滤咨询买家')}
      </Checkbox>
      {enable && (
        <section className="flex items-center flex-wrap py-2 px-4 bg-fill-100">
          {platform !== disable1Platform && (
            <div className="flex items-center whitespace-nowrap mr-6 gap-2">
              <Checkbox
                disabled={disabled}
                checked={filterWaitProcessConversation}
                onChange={({ target: { checked } }) => {
                  onChange({
                    ...filterConsultBuyer,
                    filterWaitProcessConversation: checked,
                  });
                }}
                style={{ padding: '5px 0' }}
              />
              {t('aide.过滤下发时处于待处理状态的买家')}
            </div>
          )}
          <div className="flex items-center whitespace-nowrap mr-6 gap-2">
            <Checkbox
              disabled={disabled}
              checked={filterConsult}
              onChange={({ target: { checked } }) => {
                onChange({
                  ...filterConsultBuyer,
                  filterConsult: checked,
                });
              }}
            />
            <T
              keyName="aide.过滤近x天咨询过的买家"
              params={{
                x: (
                  <TransComponent
                    content={
                      <Select
                        className="mx-1"
                        disabled={disabled}
                        value={filterConsultDays}
                        onChange={(filterConsultDays) => {
                          onChange({
                            ...filterConsultBuyer,
                            filterConsultDays,
                          });
                        }}
                        options={[1, 2, 3].map((x) => ({ value: x, label: x }))}
                      />
                    }
                  />
                ),
              }}
            />
          </div>
          <div className="flex items-center whitespace-nowrap mr-6 gap-2">
            <Checkbox
              disabled={disabled}
              checked={filterConsultAfterCreateOrder}
              onChange={({ target: { checked } }) => {
                onChange({
                  ...filterConsultBuyer,
                  filterConsultAfterCreateOrder: checked,
                });
              }}
            />
            {t('aide.过滤下单后在该店铺有过咨询的买家')}
          </div>
        </section>
      )}
    </div>
  );
};
